import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id CB3BC222-1858-41C6-A488-0C2BB1FB2EA8
 * name vuejs
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vuejs.svg
 * tags
 * - Brand / Logo 
 * - Developer / Languages 
 */
export const VuejsIcon = createSvgIcon(<><path d="M2,3H5.5L12,15L18.5,3H22L12,21L2,3M6.5,3H9.5L12,7.58L14.5,3H17.5L12,13.08L6.5,3Z" /></>, 'VuejsIcon');
export default VuejsIcon